import ITexts from "./ITexts";

const de: ITexts = {
  // Description
  project_list_item_go_to_project: "Zum Projekt"
};

export default de;
